import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4003';

export interface UpgradeUser {
  id: string;
  name: string;
  phoneNumber: string;
  language: 'pt-BR' | 'en-GB';
  country: 'BR' | 'UK';
}

export interface UpgradeSubscription {
  status: 'trial' | 'expired' | 'active' | 'canceled';
  plan: string;
  trialEndsAt?: string;
}

export interface UpgradePlan {
  id: string;
  slug: string;
  name: string;
  type: 'basic' | 'pro' | 'enterprise';
  currency: 'BRL' | 'GBP' | 'USD';
  priceMonthly: string;
  priceYearly?: string;
  description?: string;
  features: string[];
  displayOrder: number;
}

export interface UpgradeData {
  user: UpgradeUser;
  subscription: UpgradeSubscription;
  plans: UpgradePlan[];
  currency: string;
}

export interface CheckoutResponse {
  checkoutUrl: string;
}

export interface UpgradeError {
  error: string;
  message: string;
}

export const upgradeService = {
  async getUpgradeData(token: string): Promise<UpgradeData> {
    const { data } = await axios.get<{ success: boolean } & UpgradeData>(
      `${API_URL}/api/upgrade`,
      { params: { token } }
    );
    return {
      user: data.user,
      subscription: data.subscription,
      plans: data.plans,
      currency: data.currency,
    };
  },

  async createCheckout(
    token: string,
    planSlug: string,
    billingCycle: 'monthly' | 'yearly'
  ): Promise<CheckoutResponse> {
    const { data } = await axios.post<{ success: boolean } & CheckoutResponse>(
      `${API_URL}/api/upgrade/checkout`,
      { token, planSlug, billingCycle }
    );
    return { checkoutUrl: data.checkoutUrl };
  },
};

export default upgradeService;
